import AuthLoading from "../../common/AuthLoading";
export default AuthLoading;
